module.exports = __webpack_public_path__ + "static/media/technology-3393230_1280.87d98db7.jpg";